module.exports = __webpack_public_path__ + "img/audio.20e74745.png";